module.exports = __webpack_public_path__ + "img/Consulting.8822b0e7.svg";